import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {},
  isLoaded: false,
  pageCount: 0,
  messageTreatments: []
};

const assignedTreatmentSlice = createSlice({
  name: "assignedTreatments",
  initialState,
  reducers: {
    setPageCount: (state, { payload }) => {
      state.pageCount = payload;
    },
    setAssignedTreatments: (state, { payload }) => {
      state.list = payload;
      state.isLoaded = true;
    },
    addAppointmentToList: (state, { payload }) => {
      state.list = [...state.list, payload];
    },
    setSelectedAssignedTreatment: (state, { payload }) => {
      state.selected = payload;
    },
    updateSelectedTreatment: (state, { payload }) => {
      state.selected = payload;
    },
    updateAssignedTreatments: (state, { payload }) => {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
      console.log('[assignedTreatmentSlice] PAYLOAD:', payload);
      state.selected =
        state.selected.id === payload.id ? payload : state.selected;
    },
    addDoctorToAssignedTreatment: (state, { payload }) => {
      state.selected.doctors = [...state.selected.doctors, payload];
    },
    setMessageTreatments: (state, { payload }) => {
      state.messageTreatments = payload;
    }
  },
});

export const {
  addDoctorToAssignedTreatment,
  setAssignedTreatments,
  addAppointmentToList,
  setSelectedAssignedTreatment,
  updateAssignedTreatments,
  updateSelectedTreatment,
  setPageCount,
  setMessageTreatments
} = assignedTreatmentSlice.actions;
export default assignedTreatmentSlice.reducer;
